var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.706 4.75a1.52 1.52 0 0 0-1.513 1.528c0 .847.68 1.528 1.513 1.528.832 0 1.528-.68 1.528-1.528 0-.847-.681-1.528-1.528-1.528ZM13.944 6.703a6.385 6.385 0 1 0 6.384 6.384 6.385 6.385 0 0 0-6.384-6.384Zm0 10.484a4.087 4.087 0 0 1-4.085-4.085 4.087 4.087 0 0 1 4.085-4.084 4.087 4.087 0 0 1 4.084 4.084 4.087 4.087 0 0 1-4.084 4.085Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.026 26.05H8.68c-4.297 0-7.791-3.494-7.791-7.79V7.912c0-4.296 3.494-7.79 7.79-7.79h10.348c4.297 0 7.791 3.494 7.791 7.79V18.26c0 4.296-3.494 7.79-7.79 7.79ZM8.68 2.558a5.365 5.365 0 0 0-5.356 5.355V18.26a5.365 5.365 0 0 0 5.356 5.355h10.347a5.365 5.365 0 0 0 5.356-5.355V7.912a5.365 5.365 0 0 0-5.356-5.355H8.68Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/IG.4bff0175e53ab661de39199b2a2b98cc.svg";
export { ForwardRef as ReactComponent };